<template>
    <div>
        <AboutPage/>
        <div
            id="focusTool"
            v-if="amendmentOpen"
        >
            Projects Being Displayed <br/>
            <button
                id="adoptedButton"
                class="focusButton"
                :class="{selectedButton: selectAdopted}"
                v-on:click='selectFocus("Adopted")'
            >
                2026-2029 <br/>TIP
            </button>
            <button
                id="amendedButton"
                class="focusButton"
                :class="{selectedButton: !selectAdopted}"
                v-on:click='selectFocus("Amendment")'
            >
                Amendment <br/>26:5 (Full)
            </button>
        </div>

        <header>
            <div style="clear: right">Filter TIP Projects</div>
        </header>


        <Group
            v-for="group in groups"
            v-bind:key="group.title"
            v-bind:title="group.title"
            v-bind:dropdowns="group.dropdowns"
            v-bind:clear="clear"
            v-bind:symbology="symbology"
            v-on:input="$emit('input', $event)"
            v-on:symbolChange="$emit('symbolChange', $event)"
        />
        <streetFilter
            v-on:input="$emit('input', $event)"
            v-bind:clear="clear"
        />


        <div
            v-on:click="clearFilters(true)"
            id="resetButton"
        >
            Reset All Filters
        </div>
    </div>
</template>

<script>
import Group from "./Group";
import streetFilter from "./streetFilter";
import AboutPage from "./AboutPage";

export default {
    name: "SideBar",
    components: {Group, streetFilter, AboutPage},
    props: ['construction_years', 'FACs', 'filter_FAC', 'filter_construction_year', 'jurisdictions',
        'filter_project_type', 'filter_street', 'filter_jurisdiction', 'project_types', 'counties', 'symbology',
        'focus', 'amendmentOpen'],
    data: function () {
        return {
            clear: false
        }
    },
    computed: {
        groups: function () {
            return [
                {
                    title: "Project Type",
                    dropdowns: [
                        {
                            name: "TYPE",
                            values: this.project_types,
                            selected: this.filter_project_type,
                        },
                    ],
                },
                {
                    title: "Obligation Year",
                    dropdowns: [
                        {
                            name: "CONYear",
                            values: this.construction_years,
                            selected: this.filter_construction_year,
                        },
                    ],
                },
                {
                    title: "Federal Aid Committee",
                    dropdowns: [
                        {
                            name: "FAC",
                            values: this.FACs,
                            selected: this.filter_FAC,
                        },
                    ],
                },
                {
                    title: "Jurisdiction",
                    dropdowns: [
                        {
                            name: "Jurisdiction",
                            values: this.jurisdictions,
                            selected: this.filter_jurisdiction,
                        },
                    ],
                },
            ]
        },
        selectAdopted: function () {
            if (this.focus && this.focus === "Amendment") {
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        clearFilters () {
            this.clear = true;
            setTimeout(() => {this.clear = false;}, 1000);
        },
        selectFocus (layer) {
            console.log(layer);
            if (layer === "Amendment") {
                this.selectAdopted = false;
                this.$emit('focusChange', 'Amendment');
            } else {
                this.selectAdopted = true;
                this.$emit('focusChange', 'Adopted');
            }
        }
    },

}
</script>

<style scoped>
div {
    background-color: #0f2d53;
}

header {
    color: white;
    padding: 5px;
    margin-top: 15px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 1.25rem;
}

#resetButton {
    color: #111;
    background: #d2d2d2;
    font-family: Arial, Helvetica, sans-serif;
    width: fit-content;
    font-weight: bold;
    padding: 15px;
    margin: auto;
    border-radius: 5px;
    box-shadow: 3px 5px #2f4d73;
}

#resetButton:hover {
    background: #b2b2b2;
    cursor: pointer;
}

#resetButton:active{
    background: #929292;
    color: black;
}

#focusTool {
    clear: right;
    color: #fff;
    background: #64983D;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    padding: 4px 2px;
    font-size: 1.25rem;
    margin-bottom: 1px;
    line-height: 1;
    text-align: center;
    border-color: #0F2D53;
    border-width: medium;
    border-style: solid;
}

.focusButton {
    background: #222222;
    cursor: pointer;
    color: #aaa;
    width: 50%;
    font-size: 1.25rem;
    margin-bottom: 1px;
}

.focusButton:hover {
    background: #444444;
    color: #fff;
}

.focusButton:active {
    background: #bbbbbb;
    color: black;
}

.selectedButton {
    /*background: #ea711b;*/
    background: #B23346;
    color: #fff;
}

.selectedButton:hover {
    /*background: #fb822c;*/
    background: #921326;
}

.selectedButton:active {
    /*background: #ffa200;
    color: #fff;*/
    background: #E26376;
    color: #000;
}
</style>
